"use strict";

/* eslint-disable no-bitwise */
/* eslint-disable no-mixed-operators */

// Based on https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript

/* globals crypto, Uint32Array */

function cryptoUID() {
	var buf = new Uint32Array(4);
	crypto.getRandomValues(buf);
	var idx = -1;
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
		idx++;
		var r = (buf[idx >> 3] >> ((idx % 8) * 4)) & 15;
		var v = c === "x" ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

function mathUID() {
	var d = new Date().getTime();
	if (typeof performance !== "undefined" && typeof performance.now === "function") {
		d += performance.now(); // use high-precision timer if available
	}
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
		var r = (d + (Math.random() * 16)) % 16 | 0;
		d = Math.floor(d / 16);
		return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
	});
}

var cryptoSupported = typeof (Uint32Array) === "function" && typeof (crypto) !== "undefined" &&
              typeof (crypto.getRandomValues) !== "undefined";

var uuid = cryptoSupported ? cryptoUID : mathUID;
